module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/bus-list/bus-list.component.scss
// module id = 1187
// module chunks = 0